/**
 * The project the reader is looking at, from the URL.
 *
 * Four places open the New card dialog and two of them — the sidebar's button
 * and the mobile top bar's — used to open it with no scope at all, so the
 * dialog fell back to the *last* project used. On a project page that is a
 * quiet way to file a card somewhere else: the card is created, its peek
 * opens over a list that does not contain it, and the list you were looking at
 * never moves (#62). The palette and the `c` hotkey already read the key off
 * the path; this is that regex, in one place, for all four.
 */
import { useRouterState } from '@tanstack/react-router';

const PROJECT_PATH = /^\/projects\/([^/]+)/;

/** The key in `/projects/:key`, or undefined anywhere else in the app. */
export function useCurrentProjectKey(): string | undefined {
  return useRouterState({
    select: (state) => PROJECT_PATH.exec(state.location.pathname)?.[1],
  });
}

/** What to open the New card dialog with, given where the reader is. */
export function newCardTarget(projectKey: string | undefined): { projectKey?: string } {
  return projectKey ? { projectKey } : {};
}
